import type { Brand } from '@/domainLogic/index.ts';
import { Text } from '@lmn/design-system';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import type { GroupedPromotion } from '@/app/components/hotel-detail/rooms/groupPromotionsByLabel';
import OpenXModal from '@/app/components/search/components/Modal/OpenXModal';
import ModalHeader from '@/app/components/search/components/Modal/LayoutElements/ModalHeader';

type EvoRoomPromotionInformationModalProps = {
  promotion: GroupedPromotion;
  isOpen: boolean | undefined;
  onDismiss: () => void;
  onOpenByBrowserHistory?: () => void;
};

export function EvoRoomPromotionInformationModal(props: EvoRoomPromotionInformationModalProps) {
  const { promotion, isOpen, onDismiss, onOpenByBrowserHistory } = props;
  const { staticData, commonData, localization } = usePageWrapperData();
  const isMobile = commonData.isMobileDevice;

  return (
    <OpenXModal
      isOpen={isOpen ?? false}
      isMobile={isMobile ?? true}
      brand={staticData.domainValues?.brand as Brand}
      onClose={onDismiss}
      onCloseByBrowserHistory={onDismiss}
      onOpenByBrowserHistory={onOpenByBrowserHistory}
      fullScreen={false}
      id={`promotion-modal-${promotion.type}`}
      aria-label={promotion.label}
      bodyBackgroundColor="backgroundLayer02"
      scrollShadows={localization?.configValuesApp?.evolutionEnabled}
      header={{
        sticky: true,
        element: <ModalHeader handleClose={onDismiss}>{promotion.label}</ModalHeader>,
      }}
    >
      {/* A grouped promotion (same label, several value adds) carries every distinct
          description — render one line per description. */}
      {promotion.descriptions.map((description) => (
        <Text variant="Body" key={description}>
          {description}
        </Text>
      ))}
    </OpenXModal>
  );
}
